import { render, staticRenderFns } from "./Subgrafik.vue?vue&type=template&id=9d7c91dc&"
import script from "./Subgrafik.vue?vue&type=script&lang=js&"
export * from "./Subgrafik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports